export default function RailSearchFormController(
    $scope,
    $rootScope,
    $controller,
    $stateParams,
    railsFactory,
    l10nService,
    railAmendmentService,
    timeSlots,
    staticData) {

    'ngInject';

    const vm = this;
    Object.assign(vm, {
        $onInit,
        isRoundtripTabEnabled,
    });

    Object.assign($scope, {
        locationPlaceholder: l10nService.localize('City, train station...'),
        moreOptionsTemplate: 'app/modules/ukrail/directives/templates/moreOptions.tmpl.html',
        travellersTemplate: 'app/modules/ukrail/directives/templates/travellers.tmpl.html',
    });

    function $onInit() {
        vm.isAmendmentMode = railAmendmentService.isAmendmentMode();
        if (vm.isAmendmentMode) {
            railAmendmentService.initAmendmentMode($rootScope, railsFactory);
        }
        $scope.options.type = [
            {text: l10nService.localize('Leaving by'), value: 'false'}, {text: l10nService.localize('Arriving by'), value: 'true'},
        ];
    }

    function isRoundtripTabEnabled() {
        return !!$stateParams.rebook;
    }

    $controller('RailSearchFormBaseController', {
        $scope,
        railsFactory,
        settingsAirlines: [],
        timeSlots,
        $stateParams,
        staticData,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailSearchFormCtrl.js